// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__eX0G1","page":"style_page__UzPcL","next":"style_next__OsQ_9","break":"style_break__ShZrL","active":"style_active__qwukk"};